import type { z } from 'zod';
import {
  campaignStepSchema,
  customizeAdStepSchema,
  detailsStepSchema,
  selectVideoOnlyStepSchema,
  targetTypeStepSchema,
} from '../-schema';
import type { AdWizardFormData } from '../-schema';

export interface WizardStep {
  id: string;
  schema: z.ZodSchema;
  showIf?: (
    data: Partial<AdWizardFormData>,
    context?: { selectedCampaignFollowUpType?: string }
  ) => boolean;
}

// Booking-funnel campaigns choose Service or Packages before Details.
// Other campaigns retain Details → Content → Preview after campaign selection.
const ALL_STEPS: WizardStep[] = [
  { id: 'campaign', schema: campaignStepSchema },
  {
    id: 'target-type',
    schema: targetTypeStepSchema,
    showIf: (_data, context) =>
      context?.selectedCampaignFollowUpType === 'booking_funnel',
  },
  { id: 'details', schema: detailsStepSchema },
  { id: 'select-media', schema: selectVideoOnlyStepSchema },
  { id: 'customize', schema: customizeAdStepSchema },
];

export function getActiveSteps(
  data: Partial<AdWizardFormData>,
  context?: {
    selectedCampaignFollowUpType?: string;
    /** When campaign is already chosen (e.g. mobile from campaign detail). */
    skipCampaign?: boolean;
  }
): WizardStep[] {
  return ALL_STEPS.filter((s) => {
    if (context?.skipCampaign && s.id === 'campaign') {
      return false;
    }
    return !s.showIf || s.showIf(data, context);
  });
}
